import React from 'react';

const Subtitle = ({ className, children }) => (
  <p className={`t-ma0 t-pt1 truncate gray f--3 fw4 ${className}`}>
    {children}
  </p>
)

Subtitle.defaultProps = {
  className: ''
};

export default Subtitle;
